import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import NavBar from "./components/NavBar";
import HomePage from "./components/HomePage";
import EditPage from "./components/EditPage";

function App() {
  return (
    <div>
      <NavBar />
      <main className="container">
        <Routes>
          <Route path="/" element={<Navigate to="/buy" replace />} />
          <Route path="/buy" element={<HomePage view="buy" />} />
          <Route path="/sell" element={<HomePage view="sell" />} />
          <Route path="/stock" element={<HomePage view="stock" />} />
          <Route path="/mylego" element={<EditPage isNew={true} />} />
          <Route path="/mylego/:itemId" element={<EditPage isNew={false} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export default App;
